import './App.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import CreatePasswordPage from './components/CreatePasswordPage/CreatePasswordPage';
import LandingPage from './components/LandingPage/LandingPage';
import HeaderDefault from './components/HeaderDefault/HeaderDefault';

import ForgotPassword from './components/ForgotPassword/ForgotPassword';

import LoginPage from './components/Login/LoginPage';
import SignupPage from './components/Signup/SignupPage';
import Messages from './components/Messages/Messages';
import MyProfile from './components/MyProfile/MyProfile';
import HeaderUserLogin from './components/HeaderUserLogin/HeaderUserLogin';
import HeaderLogin from './components/HeaderLogin/HeaderLogin';
import CompanyProfile from './components/CompanyProfile/CompanyProfile';
import EditCompanyProfile from './components/EditCompanyProfile/EditCompanyProfile';
import CreateCompanyProfileSearch from './components/CreateCompanyProfileSearch/CreateCompanyProfileSearch';
import ServicesList from './components/ServicesList/ServicesList';
import MainDashboard from './components/MainDashboard/MainDashboard';
import NonCompanyProfile from './components/NonCompanyProfile/NonCompanyProfile';
import WriteAReview from './components/WriteAReview/WriteAReview';
import CompnayProfileDetailed from './components/CompnayProfileDetailed/CompnayProfileDetailed';
import LookingFor from './components/LookingFor/LookingFor';
import ProposalLeads from './components/ProposalLeads/ProposalLeads';
import LeadsDashboard from './components/LeadsDashboard/LeadsDashboard';
import ProductList from './components/ProductList/ProductList';
import Get3Quotes from './components/Get3Quotes/Get3Quotes';
import ProductDetailedPage from './components/ProductDetailedPage/ProductDetailedPage';
import ServiceListBeforeLogin from './components/ServiceListBeforeLogin/ServiceListBeforeLogin';
import Forum from './components/Forum/Forum';
import RequestOwnershipForm from './components/RequestOwnershipForm/RequestOwnershipForm';
import MyReviews from './components/MyReviews/MyReviews';
import Community from './components/Community/Community';
import LeadCrm from './components/LeadCrm/LeadCrm';
import MyShortList from './components/MyShortList/MyShortList';
import AccountSettings from './components/AccountSettings/AccountSettings';
import Announcement from './components/Announcement/Announcement';
import Notification from './components/Notification/Notification';



function App() {
  return (
    <div className="App">

<Router>
      <div className="App">
      <Routes>
      <Route path="/"  element={<><Header /> <LandingPage /></>}  />
      <Route path="/LoginPage"  element={<><HeaderDefault /><LoginPage /></>} />
      <Route path="/SignupPage"  element={<><HeaderDefault /><SignupPage /></>} />
      <Route path="/forgot-password"  element={<><HeaderDefault /><ForgotPassword /></>} />
      <Route path="/create-password"  element={<><HeaderDefault /><CreatePasswordPage /></>} />
      <Route path="/myprofile" element={<><HeaderUserLogin /> <MyProfile /></> } />
      <Route path="/maindashboard" element={<><HeaderUserLogin /> <MainDashboard /></> } />
      <Route path="/AccountSettings" element={<><HeaderUserLogin /> <AccountSettings /></> } />
      <Route path="/noncompanyprofile" element={<><HeaderUserLogin /> <NonCompanyProfile /></> } />
      <Route path="/writereview" element={<><HeaderUserLogin /> <WriteAReview /></> } />
      <Route path="/companyprofile" element={<><HeaderUserLogin /> <CompanyProfile /></> } />
      <Route path="/requestownershipform" element={<><HeaderUserLogin /> <RequestOwnershipForm /></> } />
      <Route path="/editcompanyprofile" element={<><HeaderUserLogin /> <EditCompanyProfile /></> } />
      <Route path="/Messages"  element={<><HeaderUserLogin /><Messages /></>} />
      <Route path="/CreateCompanyProfileSearch" element={<><HeaderUserLogin /> <CreateCompanyProfileSearch /></> } />
      <Route path="/ProductDetailedPage" element={<><HeaderUserLogin /> <ProductDetailedPage /> </>} />
      <Route path="/CompnayProfileDetailed" element={<><HeaderUserLogin /> <CompnayProfileDetailed /></> } />
      <Route path="/LookingFor" element={<><HeaderUserLogin /> <LookingFor /></> } />
      <Route path="/ProposalLeads" element={<><HeaderUserLogin /> <ProposalLeads /></> } />
      <Route path="/MyReviews" element={<><HeaderUserLogin /> <MyReviews /></> } />
      <Route path="/Notification" element={<><HeaderUserLogin /> <Notification /></> } />
      <Route path="/LeadsDashboard" element={<><HeaderUserLogin /> <LeadsDashboard /></> } />
      <Route path="/ProductList" element={<><HeaderUserLogin /> <ProductList /> </>} />
      <Route path="/Get3Quotes" element={<><HeaderUserLogin /> <Get3Quotes /> </>} />
      <Route path="/ProductDetailedPage" element={<><HeaderUserLogin /> <ProductDetailedPage /> </>} />
      <Route path="/ServiceListBeforeLogin" element={<><HeaderDefault /> <ServiceListBeforeLogin /></> } />
      <Route path="/ServicesList" element={<><HeaderUserLogin /> <ServicesList /></> } />
      <Route path="/MyShortList" element={<><HeaderUserLogin /> <MyShortList /></> } />
      <Route path="/Forum" element={<><HeaderUserLogin /> <Forum /></> } />
      <Route path="/Community" element={<><HeaderUserLogin /> <Community /></> } />
      <Route path="/Announcement" element={<><HeaderUserLogin /> <Announcement /></> } />
      <Route path="/LeadCrm" element={<><HeaderUserLogin /> <LeadCrm /></> } />



      </Routes>
      </div>
    </Router>


    </div>
  );
}


export default App;
